module.exports = __webpack_public_path__ + "static/media/right_arrow.fdc70f25.svg";